import React from 'react';
import PropTypes from 'prop-types';
import SVGIcon from '../../../../../../common/react/components/svg-icon';

import { coalesce } from '../../utilities';

export default class TableMatrix extends React.Component {
	static propTypes = {
		columns: PropTypes.array.isRequired,
		rows: PropTypes.array.isRequired,
		style: PropTypes.string.isRequired,
		activeInputs: PropTypes.bool.isRequired,
		response: PropTypes.object
	}

	render() {
		let {
			columns,
			rows,
			style,
			activeInputs
		} = this.props;

		const responseData = coalesce(this.props, 'response', '');

		return (
			<div ref='matrix' className='matrix'>
				<header>
					<div className='columns'>
						{
							columns.map(column => {
								return (
									<div className='column label' key={`${column.uniqueId}_header`}>
										{column.label}
									</div>
								);
							})
						}
					</div>
				</header>
				{
					rows.map(row => {
						let selections = [];

						if ( responseData !== '' ) {
							responseData.fields.map(field => {
								if (field.hasOwnProperty('group') && row.uniqueId === field.group.uniqueId ) {
									selections = field.selections;
								}
							});
						}

						return (
							<div className='row' key={row.uniqueId}>
								<div className='label column'>
									{row.label}
								</div>
								<div className='columns'>
									{
										columns.map(column => {
											if (activeInputs) {
												let checked = false;

												if (responseData !== '') {
													selections.map(selection => {
														if (selection.uniqueId === column.uniqueId) {
															checked = true;
														}
													});
												}

												return (
													<div className='input column' key={`${row.uniqueId}_${column.uniqueId}`}>
														<input
															ref={`${row.uniqueId}_${column.uniqueId}`}
															id={`${row.uniqueId}_${column.uniqueId}`}
															type={style}
															name={row.uniqueId}
															defaultChecked={checked}
														/>
														<label htmlFor={`${row.uniqueId}_${column.uniqueId}`}>
															<span className='label'>{column.label}</span>
														</label>
													</div>
												);
											} else {
												return (
													<div className='input column' key={`${row.uniqueId}_${column.uniqueId}`}>
														{ style === 'radio' &&
															<SVGIcon name='filled-circle' />
														}
														{ style === 'checkbox' &&
															<SVGIcon name='filled-square' />
														}
														<span className='label'>{column.label}</span>
													</div>
												);
											}
										})
									}
								</div>
							</div>
						);
					})
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/components/widgets/table-matrix.js